import { YearbookRow, YearbookWeekGroup } from '../types';

export function groupRows(rows: YearbookRow[]): YearbookWeekGroup[] {
  const groups = new Map<string, YearbookRow[]>();
  const order: string[] = [];
  rows.forEach((row) => {
    const current = groups.get(row.weekKey);
    if (current) current.push(row);
    else {
      groups.set(row.weekKey, [row]);
      order.push(row.weekKey);
    }
  });
  return order
    .map((weekKey) => toWeek(weekKey, groups.get(weekKey) || []))
    .sort(compareWeeks);
}

function toWeek(weekKey: string, rows: YearbookRow[]): YearbookWeekGroup {
  const categories: YearbookWeekGroup['categories'] = [];
  rows.forEach((row) => {
    const name = row.category.trim() || 'Utan kategori';
    const existing = categories.find((category) => category.category === name);
    if (existing) existing.rows.push(row);
    else categories.push({ category: name, rows: [row] });
  });
  const first = rows[0];
  const familyIds = Array.from(new Set(rows.map((row) => row.windowFamilyId).filter((id): id is string => Boolean(id))));
  return {
    weekKey,
    announcementDate: first?.announcementDate ?? null,
    announcementRaw: first?.announcementRaw ?? '',
    statedWeek: first?.statedWeek ?? null,
    revisionWeek: first?.revisionWeek ?? null,
    revisionYear: first?.revisionYear ?? null,
    windowFamilyId: familyIds.length === 1 ? familyIds[0] : null,
    productCount: rows.filter((row) => row.articleName.trim() || row.articleNumber.trim()).length,
    categories,
  };
}

function compareWeeks(left: YearbookWeekGroup, right: YearbookWeekGroup): number {
  if (left.announcementDate && right.announcementDate && left.announcementDate !== right.announcementDate) {
    return left.announcementDate < right.announcementDate ? -1 : 1;
  }
  if (!left.announcementDate && right.announcementDate) return 1;
  if (left.announcementDate && !right.announcementDate) return -1;
  return (left.revisionYear ?? 0) - (right.revisionYear ?? 0)
    || (left.revisionWeek ?? 0) - (right.revisionWeek ?? 0);
}
